module.exports = __webpack_public_path__ + "12dbed7c0faa158ad2160492104fa183.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/theater.jpg
// module id = 781
// module chunks = 0